import styled from "styled-components";
import { Colors } from "../../constants/Colors";

interface SubtitleProps {
  fontSize?: string;
  color?: string;
}

export const Container = styled.div`
    height: 100vh;
    width: 100vw;
    position: relative;
`;

export const MissingTotemId = styled.div`
    height: 100vh;
    width: 100vw;
    z-index: 1000;
    background-color: ${Colors.transparent.white80};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.5rem;
`;

export const GradientContainer = styled.div`
    height: 100%;
    width: 100%;
    background: linear-gradient(to bottom, transparent 0%, ${Colors.stripes.blue} 70%), repeating-linear-gradient(
        -45deg,                /* Ângulo da listra */
        ${Colors.stripes.darkBlue},              /* Azul escuro */
        ${Colors.stripes.darkBlue} 8px,         /* Tamanho da listra azul escuro */
        ${Colors.stripes.blue} 8px,         /* Azul claro (começa logo depois) */
        ${Colors.stripes.blue} 18px          /* Tamanho da listra azul clara */
    ); /* camada superior */

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

export const LogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
`;

export const LogoSuperDucha = styled.img`
    height: 165px;
    width: auto;
`;

export const Subtitle = styled.h2<SubtitleProps>`
  color: ${({ color = Colors.commons.gray }) => color};
  font-size: ${({ fontSize = "3.25rem" }) => fontSize};
  font-weight: normal;
  margin: 0;
  text-align: center;
  max-width: 90%;
`;